
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'glass' | 'gradient';
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  variant = 'default',
  hover = false,
}) => {
  const baseClasses = 'rounded-xl transition-all duration-300';
  
  const variants = {
    default: 'bg-white/5 border border-white/10 backdrop-blur-sm',
    glass: 'bg-gradient-to-br from-white/10 to-white/5 border border-white/20 backdrop-blur-md',
    gradient: 'bg-gradient-to-br from-primary-500/20 to-indigo-600/20 border border-primary-400/30',
  };
  
  const hoverEffect = hover ? 'hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-primary-500/20 cursor-pointer' : '';
  
  return (
    <div className={`${baseClasses} ${variants[variant]} ${hoverEffect} ${className}`}>
      {children}
    </div>
  );
};
